import { render, staticRenderFns } from "./TableBordered.vue?vue&type=template&id=5b61222a&"
import script from "./TableBordered.vue?vue&type=script&lang=js&"
export * from "./TableBordered.vue?vue&type=script&lang=js&"
import style0 from "./TableBordered.vue?vue&type=style&index=0&id=5b61222a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports